// extracted by mini-css-extract-plugin
export var link = "styles-module--link--2ltbD";
export var link_l = "styles-module--link_l--2gVXs";
export var link_r = "styles-module--link_r--H6ANC";
export var link_arrow = "styles-module--link_arrow--27Dqp";
export var link_title = "styles-module--link_title--pSDz0";